import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { changeList } from '../../../redux/actions/ListActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import AccessContainer from '../../access/AccessContainer';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';

class ListAccessComponent extends Component<Props> {
  public render() {
    const {
      list: { list },
    } = this.props;
    const access: AccessBase = { permission: list.permission, collaborators: list.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('List')} />;
  }

  public changeAccess = (access: AccessBase) => {
    const {
      list: { list },
      changeList,
    } = this.props;
    list.permission = access.permission;
    list.collaborators = access.collaborators;
    changeList(list);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  list: state.list,
});

const dispatchProps = { changeList };
const connector = connect(mapStateToProps, dispatchProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ListAccessComponent);
